/* import __COLOCATED_TEMPLATE__ from './search.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type KnowledgeHubApi from 'embercom/lib/knowledge-hub/list-api';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

interface Args {
  searchTerm?: string;
  linkedUrls?: string[];
  setSearchTerm: (searchTerm?: string) => void;
  setLinkedUrls: (linkedUrls?: string[]) => void;
  titleTerm?: string;
  setTitleTerm: (titleTerm?: string) => void;
  bodyTerm?: string;
  setBodyTerm: (bodyTerm?: string) => void;
  urlTerm?: string;
  setUrlTerm: (urlTerm?: string) => void;
  listApi: KnowledgeHubApi;
  beforeSearch?: () => void;
}

const SEARCH_ANALYTICS_OBJECT = 'search';
const SEARCH_ANALYTICS_PLACE = 'knowledge_hub';

export default class Search extends Component<Args> {
  @service declare intercomEventService: $TSFixMe;

  @action
  async performSearchTransition(queryParams: any) {
    this.args.setSearchTerm(queryParams.search_term);
    this.args.setLinkedUrls(queryParams.url_partials);
    this.args.setTitleTerm(queryParams.title_term);
    this.args.setBodyTerm(queryParams.body_term);
    this.args.setUrlTerm(queryParams.url_term);
    this.intercomEventService.trackAnalyticsEvent({
      action: 'searched',
      object: SEARCH_ANALYTICS_OBJECT,
      place: SEARCH_ANALYTICS_PLACE,
    });
    this.args.beforeSearch?.();
    await this.args.listApi.search(
      queryParams.search_term,
      queryParams.url_partials,
      queryParams.title_term,
      queryParams.body_term,
      queryParams.url_term,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Search': typeof Search;
    'knowledge-hub/search': typeof Search;
  }
}
